module.exports = __webpack_public_path__ + "media/images/menu-2357d5c21fd747bc5e14000685c367d6.svg";